module.exports = __webpack_public_path__ + "img/wifiblock-desktop-kitchen.fd56d9a6.png";